<template>
  <div class="embedded-catalog-data-queries-div">
    <div class="catalog-data-queries-list">
      <div v-for="query in queries" :key="query.id" class="row">
        <div :class="isStaff(currentUser) ? 'col-sm-9' : 'col-sm-12'">

          <div id="`query-${query.id}`" class="media">
            <div class="media-left">
              <customer-icon :query="query" />
            </div>
            <div class="media-body">
              <h5 class="media-heading">
                  {{ userName(query.user) }}
                <small>{{formatDateTime(query.created_at)}}</small>
              </h5>

              
              <query-details-with-editor
                :query="query"
                :current-user='currentUser'
                :response-templates='responseTemplates'
                @reload-queries="reloadQueries"
              />

            </div>
          </div>

        </div>


        <div v-if="isStaff(currentUser)" class="col-sm-3">
          <query-status
            :query="query"
          />
          <div v-if="query.status == 'staff'" style="height: 7em"> </div>
        </div>

      </div>
    </div>

    <br/>

    <div v-if="!currentUser.email && !isStaff(currentUser)" class="alert alert-warning" role="alert">
        Ennenkuin voit karhuta tai lähettää kysymyksiä niin ole hyvä ja <a :href="`/user/${currentUser.user_id}/edit`">aseta sähköpostisi</a>.
    </div>
    <div v-else>
      <query-editor 
        :product-id="productId"
        :parent-id="parentId"
        :current-user="currentUser"
        :response-templates="responseTemplates"
        :back-url="backUrl"
        :fast-query="productExists ? true : false"
        :product-kuvailu-tulossa="productKuvailuTulossa"
        @reload-queries="reloadQueries"
      />
    </div>

  </div>
</template>

<script>

import moment from 'moment';

import { userMixin } from '@/mixins/userMixin.js'
import QueryDetails from './QueryDetails.vue'
import QueryStatus from './QueryStatus.vue'
import QueryDetailsWithEditor from './QueryDetailsWithEditor.vue'

export default {
  components: {
    QueryDetails,
    QueryStatus,
    QueryDetailsWithEditor,
  },

  mixins: [
    userMixin,
  ],

  props: {
    productId: String,
    parentId: String,
    currentUser: Object,
    responseTemplates: Array,
    backUrl: String,
    productExists: Boolean,
    productKuvailuTulossa: Boolean,
  },

  data() {
    return {
      queries: [],
    }
  },

  created() {
    this.fetchQueries()
  },

  methods: {
    fetchQueries() {
      this.loading = true
      this.error = false
      
      axios.get(`/luettelointi/kysely`, {
        params: {
          'product_id': this.productId,
          'parent_id': this.parentId,
        }
      })
      .then((response) => {
        console.log(response)
        this.queries = response.data.queries
      })
      .catch((error) => {
        this.error = true
        console.log(error)
      })
      .finally(() => {
        this.loading = false
      });
    },

    reloadQueries() {
      this.fetchQueries()
    },

    formatDateTime(dateTime) {
      return moment(dateTime).format('YYYY-MM-DD HH:mm')
    },
  },

}

</script>
